<template>
	<div>
		<modalDetail :dialog="dialogDetail" @hideDialog="() => { dialogDetail = false }"></modalDetail>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<div class="d-flex justify-space-between">
			<div class="text-h5" v-if="$route.name == 'list-purchase-delivery-order'">Data Penerimaan Barang</div>
			<div class="text-h5" v-else>Data Penerimaan Barang Warehouse</div>
		</div>
		<div v-if="loading">
			<loading-card></loading-card>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3" outlined>
				<v-list color="deep-purple lighten-5" class="pa-3">
					<v-list-item dense class="px-1">
						<v-spacer></v-spacer>
						<v-btn text depressed class="primary mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mt-3" v-if="dropfilter">
					<v-col cols="12" class="px-4 pb-1">
						<v-row>
							<v-col cols="12" md="3">
								<v-text-field dense outlined hide-details label="Kode Pengiriman" v-model="pdo_code.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="3">
								<v-menu v-model="menuDateCreate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(created_date)" label="Tanggal Dibuat" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
									</template>
									<v-date-picker locale="id" range color="primary" v-model="created_date"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="3">
								<v-menu v-model="menuDateDeliver" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(delivery_date)" label="Tanggal Dikirim" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
									</template>
									<v-date-picker locale="id" range color="primary" v-model="delivery_date"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete item-text="status" item-value="code" outlined dense hide-details v-model="pdo_status.value" :items="status_list" label="Status PDO" no-data-text="Belum ada data tersedia"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete item-text="supplier_name" item-value="supplier_id" outlined dense hide-details v-model="pdo_supplier.value" :items="listSupplier" label="Supllier" no-data-text="Belum ada data tersedia"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete v-if="$route.name == 'list-purchase-delivery-order-warehouse'" item-text="warehouse_name" item-value="warehouse_id" outlined dense hide-details v-model="pdo_warehouse.value" :items="listWarehouse" label="Warehouse" no-data-text="Belum ada data tersedia"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="3">
							</v-col>
							<v-col cols="12" md="3" class="text-right">
								<v-btn @click="resetFilter" outlined color="grey darken-1" dark class="text-capitalize">Reset</v-btn>
								<v-btn @click="cari" depressed color="primary" dark class="ml-2 text-capitalize">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card>
			</v-slide-y-transition>
			<div outlined v-if="listPDO.length == 0 && pdoPagination">
				<div class="py-3">
					<not-found></not-found>
				</div>
			</div>
			<div v-else>
				<v-row class="mr-0">
					<v-col cols="12" md="12" class="pb-0 pr-0" >
						<v-card class="mb-3" outlined v-for="pdo in listPDO" :key="pdo.pdo_id">
							<v-list color="deep-purple lighten-5" class="pt-0 pb-0">
								<v-list-item dense>
									<v-list-item-content class="grey--text text--darken-2">
										Kode Pengiriman {{ pdo.pdo_code }}
									</v-list-item-content>
									<v-spacer></v-spacer>
									<v-btn small text depressed class="primary" @click="printPDO(userData.user_warehouse_id, pdo.pdo_code)">
										<v-icon>mdi-printer</v-icon>
										<div class="pl-2 text-capitalize">Print</div>
									</v-btn>
								</v-list-item>
							</v-list>
							<v-list-item>
								<v-list-item-content>
									<v-layout wrap>
										<v-flex xs6 sm3 md3>
											<div class="body-2 oppacity-75">Supplier</div>
											<div class="subtitle-2">{{ pdo.supplier_name }}</div>
										</v-flex>
										<v-flex xs6 sm3 md3>
											<div class="body-2 oppacity-75">Kode Pemesanan</div>
											<div class="subtitle-2">{{ pdo.po_code }}</div>
										</v-flex>
										<v-flex xs6 sm3 md3>
											<div class="body-2 oppacity-75">Estimasi Diterima</div>
											<div class="subtitle-2">{{ pdo.pdo_estimated_received_date | haritanggal }}</div>
										</v-flex>
										<v-flex xs6 sm3 md3>
											<div class="body-2 oppacity-75">Status</div>
											<div class="subtitle-2">{{ pdo.pdo_status | toStatusPDOWH }}</div>
										</v-flex>
										<v-flex xs3 sm3 md3>
											<div class="body-2 pt-3">
												<v-icon small>mdi-phone</v-icon><span class="pl-2">{{ pdo.supplier_mobilephone }}</span>
											</div>
											<div class="body-2 pt-1">
												<v-icon small>mdi-email</v-icon><span class="pl-2">{{ pdo.supplier_email }}</span>
											</div>
										</v-flex>
										<v-flex xs6 sm6 md6>
											<div v-if="$route.name == 'list-purchase-delivery-order-warehouse'" class="pt-2">
												<div class="body-2 oppacity-75">Warehouse Tujuan</div>
												<div class="subtitle-2">{{ pdo.warehouse_name }}</div>
											</div>
										</v-flex>
										<v-flex xs3 sm3 md3>
											<div class="pt-5">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(pdo.pdo_code)">
															<v-icon dark>mdi-text-box-search</v-icon>
														</v-btn>
													</template>
													<span>Detail</span>
												</v-tooltip>
											</div>
										</v-flex>
									</v-layout>
								</v-list-item-content>
							</v-list-item>
							<div class="pt-3">
								<v-card tile elevation="0">
									<v-data-table :headers="headersProduct" :items="pdo.pdo_detail" :items-per-page="1000" class="elevation-0 white-row" hide-default-footer>
										<template v-slot:item.pdo_detail_quantity_sent="{ item }">
											<div>{{ item.pdo_detail_quantity_sent | toNumber }}</div>
										</template>
										<template v-slot:item.pdo_detail_quantity_received="{ item }">
											<div v-if="item.pdo_detail_quantity_received > 0">{{ item.pdo_detail_quantity_received | toNumber }}</div>
											<div v-else>-</div>
										</template>
									</v-data-table>
								</v-card>
							</div>
						</v-card>
					</v-col>
				</v-row>
				<div class="pt-5">
					<v-row v-if="pdoPagination">
						<v-col cols="12" md="11" class="py-0 d-flex justify-end">
							<v-pagination v-model="page" @input="changePage" :length="pdoPagination.total_page" total-visible="7" circle class="d-flex justify-end"></v-pagination>
						</v-col>
						<v-col cols="12" md="1" class="py-0 pl-0">
							<v-autocomplete :items="listLimit" @input="changeLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {mapActions,  mapState, mapMutations} from 'vuex'
import modalDetail from '@/views/MLwarehouse/pdo/DetailPDO'
import modalPrint from '@/views/MLwarehouse/pdo/ModalPrintPDO'

export default {
	components: {
		modalDetail, modalPrint
	},
	data() {
		return {
			dropfilter: false,
			dialogDetail: false,
			dialogPrint: false,
			loading: true,
			page: 1,
			listLimit: [ 5, 10, 20, 50, 100 ],
			limit: 10,
			params: [],
			sortBy: 'pdo_id',
			sortDir: 'DESC',
			headersProduct: [
			{ text: 'Nama Produk', value: 'pdo_detail_product_name', sortable: false },
			{ text: 'Jumlah Dikirim', value: 'pdo_detail_quantity_sent', sortable: false, align: 'center' },
			{ text: 'Jumlah Diterima', value: 'pdo_detail_quantity_received', sortable: false, align: 'center' }
			],
			pdo_code: {
				value:'',
				comparison:'like',
				type:'string',
				field: 'pdo_code'
			},
			pdo_create_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'pdo_status_created_datetime'
			},
			pdo_delivery_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'pdo_status_on_delivery_datetime'
			},
			pdo_status: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'pdo_status'
			},
			pdo_supplier: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'po_supplier_id'
			},
			pdo_warehouse: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'po_warehouse_id'
			},
			menuDateCreate: false,
			menuDateDeliver: false,
			created_date: [],
			delivery_date: [],
		}
	},
	computed: {
		...mapState('pdo', ['listPDO', 'pdoPagination', 'OptionStatusPDO', 'listWarehouse', 'listSupplier']),
		...mapState('auth', ['userData']),

		showProccessPDO(){
			const menu_pdo = this.userData.user_privilege.find( (el) => {
				return el.menu_name == 'Penerimaan Barang'
			})
			if (!menu_pdo) {
				return false
			}
			const menu_approve_pdo = menu_pdo.menu_array.map( el => el.menu_end_point).includes('/receipt-purchase-delivery-order')
			return menu_approve_pdo
		},
		status_list() {
			return this.OptionStatusPDO.map( (el) => {
				return {
					code: el,
					status: this.$options.filters.toStatusPDOWH(el)
				}
			})
		}
	},
	methods: {
		...mapActions('pdo', ['getPDO', 'getPDOAll', 'getDetailPDO', 'exportPDO', 'exportPDOAll', 'getOptionStatusPDO', 'getOptionSupplier', 'getOptionWarehouse']),
		...mapMutations('pdo', ['clearDataPDO']),
		...mapActions('common', ['getLetterHeader']),

		getDataPDO() {
			if (this.$route.name == 'list-purchase-delivery-order') {
				this.getPDO(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
			} else if (this.$route.name == 'list-purchase-delivery-order-warehouse') {
				this.getPDOAll(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		},
		async getData() {
			await this.getDataPDO()
			await this.getOptionSupplier()
			await this.getOptionWarehouse()
			await this.getOptionStatusPDO()
			this.loading = await false
		},
		exportData(){
			if (this.$route.name == 'list-purchase-delivery-order') {
				this.exportPDO(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
			} else if (this.$route.name == 'list-purchase-delivery-order-warehouse') {
				this.exportPDOAll(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		},
		resetFilter() {
			this.pdo_code.value = ''
			this.pdo_create_date.value = ''
			this.pdo_delivery_date.value = ''
			this.created_date = []
			this.delivery_date = []
			this.pdo_status.value = ''
			this.pdo_supplier.value = ''
			this.pdo_warehouse.value = ''
			this.page = 1
			this.getDataPDO()
		},
		changePage(page) {
			this.page = page
			this.getDataPDO()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getDataPDO()
		},
		cari() {
			this.params = []
			if (this.pdo_code.value)
				this.params.push(this.pdo_code)
			if (this.pdo_create_date.value){
				if (this.pdo_create_date.value.length > 1) {
					this.pdo_create_date.value.sort()
					let date = this.pdo_create_date.value.join('::')
					this.pdo_create_date.value = date
				}
				this.params.push(Object.assign({}, this.pdo_create_date))
			}
			if (this.pdo_delivery_date.value){
				if (this.pdo_delivery_date.value.length > 1) {
					this.pdo_delivery_date.value.sort()
					let date = this.pdo_delivery_date.value.join('::')
					this.pdo_delivery_date.value = date
				}
				this.params.push(Object.assign({}, this.pdo_delivery_date))
			}
			if (this.pdo_status.value)
				this.params.push(this.pdo_status)
			if (this.pdo_supplier.value)
				this.params.push(this.pdo_supplier)
			if (this.pdo_warehouse.value)
				this.params.push(this.pdo_warehouse)
			this.page = 1
			this.getDataPDO()
		},
		getDetail(code){
			this.getDetailPDO(code).then(()=> {
				this.dialogDetail = true
			})
		},
		async printPDO(id, code) {
			await this.getLetterHeader({warehouse_id: id})
			await this.getDetailPDO(code).then(()=> {
				this.dialogPrint = true
			})
		},
	},
	created() {
		this.getData()
		this.$store.dispatch('setPageTitle', `Penerimaan Barang`)
	},
	beforeDestroy(){
		this.clearDataPDO()
	},
	watch: {
		created_date(val) {
			this.pdo_create_date.value = val
		},
		delivery_date(val) {
			this.pdo_delivery_date.value = val
		},
		$route() {
			this.resetFilter()
		}
	}
};
</script>